import { Graphics } from "pixi.js"

/** Cosmetic entity effect: a flickering crown of fire with an open center for the face. */
export class FireHalo extends Graphics {
    animate = (now = Date.now()) => {
        this.clear()
        const t = now / 1000
        this.lineStyle(5, 0xff5b16, 0.16)
        this.drawEllipse(0, 0, 12, 9)
        this.lineStyle(2, 0xff8b24, 0.85)
        this.drawEllipse(0, 0, 11, 8)
        this.lineStyle(1, 0xffe9a1, 0.9)
        this.drawEllipse(0, 0, 9, 6)
        this.lineStyle(0)
        for (let i = 0; i < 12; i++) {
            const angle = i * Math.PI * 2 / 12
            const x = Math.cos(angle) * 11, y = Math.sin(angle) * 8
            const flicker = 0.5 + 0.5 * Math.sin(t * 9 + i * 2.3)
            const height = 4 + flicker * 5
            this.beginFill(i % 2 ? 0xffa132 : 0xff5b16, 0.85)
            this.drawPolygon([x - 2, y + 1, x - 1, y - height * 0.45,
                x + Math.sin(t * 7 + i) * 2, y - height, x + 2, y + 1])
            this.endFill()
            this.beginFill(0xffedb4, 0.85)
            this.drawRect(Math.round(x), Math.round(y - 1), 1, 2)
            this.endFill()
        }
        // Small rising embers; deterministic phase keeps render frames allocation-free.
        for (let i = 0; i < 4; i++) {
            const phase = (t * 0.8 + i * 0.27) % 1
            this.beginFill(0xffcc64, (1 - phase) * 0.8)
            this.drawRect(Math.round(Math.sin(i * 2 + t) * 9), Math.round(-8 - phase * 12), 1, 1)
            this.endFill()
        }
    }
}
